import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "navs"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Perfil", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Conta", -1)
const _hoisted_4 = {
  key: 0,
  class: "nav-column"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Pagamento", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Usuários", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Cofres", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Clientes", -1)
const _hoisted_9 = {
  key: 1,
  class: "navs-main"
}
const _hoisted_10 = { class: "navmain-new-document" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" NOVO DOCUMENTO ")
const _hoisted_12 = { class: "navmain-cofre" }
const _hoisted_13 = { class: "cofre" }
const _hoisted_14 = {
  key: 0,
  class: "navs"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Perfil", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "Conta", -1)
const _hoisted_17 = {
  key: 0,
  class: "nav-column"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "Pagamento", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "Usuários", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "Cofres", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "Clientes", -1)
const _hoisted_22 = {
  key: 1,
  class: "navs-main-drawer"
}
const _hoisted_23 = {
  key: 0,
  class: "navmain-drawer-notification"
}
const _hoisted_24 = { class: "navmain-drawer-new-document" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" NOVO DOCUMENTO ")
const _hoisted_26 = { class: "navmain-drawer-cofre" }
const _hoisted_27 = { class: "cofre" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarLogo = _resolveComponent("SidebarLogo")!
  const _component_IdcardOutlined = _resolveComponent("IdcardOutlined")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_CreditCardOutlined = _resolveComponent("CreditCardOutlined")!
  const _component_TeamOutlined = _resolveComponent("TeamOutlined")!
  const _component_LockOutlined = _resolveComponent("LockOutlined")!
  const _component_ShareAltOutlined = _resolveComponent("ShareAltOutlined")!
  const _component_FileAddOutlined = _resolveComponent("FileAddOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_FolderSelectView = _resolveComponent("FolderSelectView")!
  const _component_InfoSignature = _resolveComponent("InfoSignature")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_layout_sider, {
      collapsed: _ctx.itemObj.collapsed,
      "onUpdate:collapsed": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.itemObj.collapsed) = $event)),
      trigger: null,
      class: "sidebar"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SidebarLogo, { drawer: _ctx.drawerMenu }, null, 8, ["drawer"]),
        (_ctx.isConfig)
          ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
              _createElementVNode("div", {
                class: _normalizeClass(["nav-column", { active: _ctx.currentInConfiguration === 0 }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleChangeConfiguration(0)))
              }, [
                _createVNode(_component_IdcardOutlined, { class: "icons" }),
                _hoisted_2
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["nav-column", { active: _ctx.currentInConfiguration === 1 }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleChangeConfiguration(1)))
              }, [
                _createVNode(_component_UserOutlined, { class: "icons" }),
                _hoisted_3
              ], 2),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_CreditCardOutlined, { class: "icons" }),
                    _hoisted_5
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["nav-column", { active: _ctx.currentInConfiguration === 3 }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleChangeConfiguration(3)))
              }, [
                _createVNode(_component_TeamOutlined, { class: "icons" }),
                _hoisted_6
              ], 2),
              (_ctx.isActionAdminOrSysAdmin)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["nav-column", { active: _ctx.currentInConfiguration === 2 }]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleChangeConfiguration(2)))
                  }, [
                    _createVNode(_component_LockOutlined, { class: "icons" }),
                    _hoisted_7
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.isActionPartner)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass(["nav-column", { active: _ctx.currentInConfiguration === 4 }]),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleChangeConfiguration(4)))
                  }, [
                    _createVNode(_component_ShareAltOutlined, { class: "icons" }),
                    _hoisted_8
                  ], 2))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("section", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_a_button, {
                  class: _normalizeClass(["btn-new-document", {'is-exceeded-disabled': _ctx.isExceededLimitEnvelope || _ctx.isBlockedAccount}]),
                  disabled: _ctx.isExceededLimitEnvelope || _ctx.isBlockedAccount,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.newDocument()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_FileAddOutlined),
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["class", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_FolderSelectView, { onHandleChangeCofre: _ctx.handleChangeCofre }, null, 8, ["onHandleChangeCofre"])
                ])
              ]),
              _createVNode(_component_InfoSignature, {
                collapsed: _ctx.itemObj.collapsed
              }, null, 8, ["collapsed"])
            ]))
      ]),
      _: 1
    }, 8, ["collapsed"]),
    _createVNode(_component_a_drawer, {
      placement: "left",
      visible: _ctx.drawerMenu,
      title: false,
      onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setDrawerMenu(false))),
      class: "sidebar-drawer"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SidebarLogo, { drawer: _ctx.drawerMenu }, null, 8, ["drawer"]),
        (_ctx.isConfig)
          ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
              _createElementVNode("div", {
                class: _normalizeClass(["nav-column", { active: _ctx.currentInConfiguration === 0 }]),
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleChangeConfiguration(0)))
              }, [
                _createVNode(_component_IdcardOutlined, { class: "icons" }),
                _hoisted_15
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["nav-column", { active: _ctx.currentInConfiguration === 1 }]),
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleChangeConfiguration(1)))
              }, [
                _createVNode(_component_UserOutlined, { class: "icons" }),
                _hoisted_16
              ], 2),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createVNode(_component_CreditCardOutlined, { class: "icons" }),
                    _hoisted_18
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["nav-column", { active: _ctx.currentInConfiguration === 3 }]),
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleChangeConfiguration(3)))
              }, [
                _createVNode(_component_TeamOutlined, { class: "icons" }),
                _hoisted_19
              ], 2),
              (_ctx.isActionAdminOrSysAdmin)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["nav-column", { active: _ctx.currentInConfiguration === 2 }]),
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleChangeConfiguration(2)))
                  }, [
                    _createVNode(_component_LockOutlined, { class: "icons" }),
                    _hoisted_20
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.isActionPartner)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass(["nav-column", { active: _ctx.currentInConfiguration === 4 }]),
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleChangeConfiguration(4)))
                  }, [
                    _createVNode(_component_ShareAltOutlined, { class: "icons" }),
                    _hoisted_21
                  ], 2))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("section", _hoisted_22, [
              (_ctx.isExceededLimitEnvelope)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createVNode(_component_a_alert, {
                      message: "Atenção, seu limite de envios chegou ao limite. Para continuar enviando mais envelopes, contrate um plano maior acessando a opção [GERENCIAR PLANO].",
                      type: "info"
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_a_button, {
                  class: _normalizeClass(["btn-new-document", {'is-exceeded-disabled': _ctx.isExceededLimitEnvelope || _ctx.isBlockedAccount}]),
                  disabled: _ctx.isExceededLimitEnvelope || _ctx.isBlockedAccount,
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.newDocument()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_FileAddOutlined),
                    _hoisted_25
                  ]),
                  _: 1
                }, 8, ["class", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_FolderSelectView, { onHandleChangeCofre: _ctx.handleChangeCofre }, null, 8, ["onHandleChangeCofre"])
                ])
              ]),
              _createVNode(_component_InfoSignature, {
                collapsed: _ctx.itemObj.collapsed,
                onCloseDrawer: _cache[13] || (_cache[13] = () => (_ctx.drawerMenu = !_ctx.drawerMenu)),
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setDrawerMenu(false)))
              }, null, 8, ["collapsed"])
            ]))
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}